// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const CustomViewsDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-customviewsdialogcontainer" */ "./CustomViewsDialogContainer")).then((bundle)=>{
        return {
            default: bundle.CustomViewsDialogContainer
        };
    });
export const LazyCustomViewsDialogContainer = /*#__PURE__*/ lazy(CustomViewsDialogContainerLazyLoader);
